import * as types from '../constants/actionTypes';

const initialState = {
  packages: {
    data: [],
    loading: false,
    error: '',
    total: 0
  },
  bundles: {
    data: [],
    loading: false,
    bundlesLoading: false,
    error: '',
    total: 0
  },
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.FETCH_PACKAGES_REQUEST:
      return {
        ...state,
        bundles: {
          bundlesLoading: true,
        }
      };

    case types.FETCH_PACKAGES_SUCCESS:
      if (action.res.success) {
        return {
          ...state,
          packages: {
            data: action.res.data.packages,
            total: action.res.data.total,
            error: '',
            loading: false
          },
          bundles: {
            data: action.res.data.bundles,
            total: action.res.data.total,
            error: '',
            bundlesLoading: false
          }
        };
      }
      return {
        ...state,
        packages: {
          data: [],
          total: 0,
          error: action.res.data,
          loading: false
        },
        bundles: {
          data: [],
          total: 0,
          error: action.res.data,
          loading: false,
          bundlesLoading: false,
        }
      };

    case types.FETCH_PACKAGES_FAILED:
      return {
        ...state,
        error: "Bad Request"
      };
    
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/mainReducer.js